<template>
  <v-app>
    <div id="mainContent" v-if="account">
      <div id="right-div">
        <div id="navbar">
          <v-toolbar extended prominent style="height: 70px; background-color: transparent">
            <v-toolbar-title class="mobileHeader">
              <img :src="require('./assets/nvblacknts.png')" alt="logo" width="160" style="" />
              <p style="color: #000; margin-top: -10px" class="text-h5">Hourly Production Logbook</p>
            </v-toolbar-title>

            <RouterLink v-if="userRole === 'admin' || userRole === 'user'" to="/"
              ><v-list-item class="item-hover"> LOGBOOK </v-list-item></RouterLink
            >
            <!-- <RouterLink to="/targets"><v-list-item class="item-hover" disabled> SET TARGETS </v-list-item></RouterLink> -->
            <!-- <v-list-item class="item-hover" disabled> SET TARGETS </v-list-item> -->
            <RouterLink v-if="userRole === 'admin'" to="/config"
              ><v-list-item class="item-hover"> CONFIG </v-list-item></RouterLink
            >
            <v-spacer></v-spacer>
            <v-btn @click="SignOut" class="ms-5">Sign Out</v-btn>
            <v-list-item v-if="userPhoto != null" :prepend-avatar="userPhoto" class="mobileAvatar"></v-list-item>
            <v-list-item v-else>
              <v-btn variant="flat" color="#BDBDBD" icon="mdi-account" class="mobileAvatar"></v-btn>
            </v-list-item>
          </v-toolbar>
        </div>
        <div id="subcontent" v-if="account">
          <v-btn
            icon="mdi-arrow-up"
            variant="elevated"
            color="#000"
            @click="scrollToTop"
            id="myButton"
            class="d-none noPrint"
            style="position: fixed; bottom: 130px; right: 80px; z-index: 1000"
          ></v-btn>
          <MainContent></MainContent>
        </div>
      </div>
    </div>
    <div v-else>
      <LoginPage @login="SignIn()"></LoginPage>
    </div>
    <div v-if="account" id="mainFooter">
      <h5 style="font-weight: 100; letter-spacing: 2px">Hourly Production Logbook {{ new Date().getFullYear() }}</h5>
    </div>
  </v-app>
</template>

<script>
import { getUserPhoto } from "./main.js";
import MainContent from "./components/MainContent.vue";
import LoginPage from "./LoginPage.vue";
// import axios from 'axios'
export default {
  name: "App",
  data() {
    return {
      userPhoto: null,
      account: undefined,
      accountName: "",
      alert: false,
      timeout: 5000,
      userRole: "none",
      ROLE_GROUPS: {
        admin: process.env.VUE_APP_ADMIN_ROLEID,
        user: process.env.VUE_APP_USER_ROLEID,
      },
    };
  },
  created() {
    window.addEventListener("scroll", this.actionScroll);
  },
  async mounted() {
    const msalApp = window.msalApp;
    this.account = msalApp.getActiveAccount();
    if (this.account) {
      this.accountName = this.account.name;
      this.accountEmail = this.account.username;

      const groupsProxy = this.account.idTokenClaims?.groups || [];
      const groups = groupsProxy.slice();

      this.userRole = groups.includes(this.ROLE_GROUPS.admin)
        ? "admin"
        : groups.includes(this.ROLE_GROUPS.user)
        ? "user"
        : "none";
      console.log(this.userRole);
    }

    if (this.account != "") {
      this.userPhoto = await getUserPhoto();
    }
  },
  methods: {
    actionScroll() {
      const scroll = window.scrollY;

      const buttonToTop = document.getElementById("myButton");
      if (scroll > 250) {
        buttonToTop.classList.remove("d-none");
      } else {
        buttonToTop.classList.add("d-none");
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    async SignIn() {
      await window.msalApp
        .loginPopup({})
        .then((e) => {
          window.msalApp.setActiveAccount(e.account);
          window.msacc = e.account;
          this.account = e.account;
        })
        .catch((error) => {
          console.error(`error during authentication: ${error}`);
        });
      this.$router.go();
    },
    async SignOut() {
      this.isLoading3 = true;
      await window.msalApp.logoutPopup();
      window.msalApp.setActiveAccount();
      window.msacc = undefined;
      this.account = undefined;
      this.$router.go();
      this.isLoading3 = false;
      localStorage.clear();
    },
    close() {
      this.$router.go();
    },
  },
  components: {
    MainContent,
    LoginPage,
  },
};
</script>

<style>
@font-face {
  font-family: "NorthvoltGrit";
  src: local("NorthvoltGrit-Regular"), url("/public/NorthvoltGrit-Regular.ttf");
}

html,
body {
  font-family: "NorthvoltGrit" !important;
  overflow: auto !important;
}

.v-application__wrap {
  background-color: #ededed;
}

#right-div {
  width: 100% !important;
  overflow: auto !important;
}

#subcontent {
  height: 100% !important;
  overflow: auto !important;
  margin-top: 110px;
  padding: 15px 15px 2500px;
  padding: 15px;
  font-size: 30px;
}

#mainFooter {
  position: fixed;
  bottom: 0;
  width: 100% !important;
  height: 25px;
  text-align: center;
  background-color: #212121;
  color: #fff;
  z-index: 999;
}

.router-link-active .v-list-item__content {
  color: rgb(68, 162, 122) !important;
  font-weight: bold !important;
}

.router-link-active > .v-list-item {
  text-decoration: underline !important;
  color: rgb(68, 162, 122) !important;
  text-underline-offset: 0.3em;
}

.item-hover {
  font-size: 24px;
  margin-top: 5px !important;
  margin-bottom: 0 !important;
}

.item-hover.v-list-item > .v-list-item__content {
  color: #000;
  text-decoration: none !important;
}

a {
  text-decoration: none !important;
}

#navbar {
  background-color: #fff;
  padding: 10px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
  box-shadow: 1px 12px 32px -7px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 1px 12px 32px -7px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 12px 32px -7px rgba(0, 0, 0, 0.75);
}

@media (max-width: 768px) {
  .mobileAvatar {
    display: none;
  }

  .mobileHeader {
    display: none;
  }
  .item-hover {
    font-size: 20px;
    font-weight: bold;
  }
}

@media print {
  #navbar {
    display: none;
  }
  #subcontent {
    margin-top: 0;
    padding-top: 0;
    background-color: #fff;
  }
  .noPrint {
    display: none;
  }

  #mainFooter {
    background-color: transparent !important;
  }
}
</style>
